import React, { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/configureStore";
import { BiMicrophone, BiMicrophoneOff } from "react-icons/bi";
import PublisherControlButton from "./PublisherControlButton";
import { getSessionSetting } from "../selectors";
import { setSessionSetting } from "../sessionSlice";
import useSessionId from "../useSessionId";

const TogglePublisherAudioButton = () => {
  const dispatch = useAppDispatch();
  const sessionId = useSessionId();
  const publishAudio = useAppSelector(
    getSessionSetting(sessionId, "publishAudio"),
  );

  const toggleAudio = useCallback(() => {
    dispatch(setSessionSetting(sessionId, "publishAudio", !publishAudio));
  }, [dispatch, publishAudio, sessionId]);

  return (
    <PublisherControlButton
      isActive={publishAudio ?? true}
      onClick={toggleAudio}
    >
      {publishAudio ? (
        <BiMicrophone color="white" size={35} />
      ) : (
        <BiMicrophoneOff size={40} />
      )}
    </PublisherControlButton>
  );
};

export default TogglePublisherAudioButton;
